import { PrimaryColors } from "../../style/colors";

/**
 *  BUTTON DEFINITIONS
 */

export const BUTTON_OUTLINE_BORDER = `2px solid ${PrimaryColors.base}`;
export const BUTTON_OUTLINE_BORDER_TRANSPARENT = `2px solid transparent`;

/**
 *  FONT
 */

export const FONT_FAMILY = '"IBM Plex Sans", "Helvetica", "Arial", sans-serif';

/**
 * FONT SIZES
 */

export const FONT_H1 = "32px";
export const FONT_H2 = "53px";
export const FONT_H3 = "42px";
export const FONT_H4 = "29px";
export const FONT_H5 = "22px";
export const FONT_H6 = "18px";
export const FONT_BODY1 = "16px";
export const FONT_BODY2 = "14px";
export const FONT_BUTTON = "16px";

/**
 * COLORS
 */

export const SECONDARY = "#008A32";
export const INHERIT_DEFAULT1 = "#fefefe";
export const INHERIT_DEFAULT2 = "#f8f9ff";
export const BACKGROUND = "#ebedef";
